<template>
  <div>
    <b-modal ref="expensesProjectionModal" size="lg" title="Set Projection">
      <form>

        <div v-if="false" class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div v-if="showMonth" class="form-group">
          <label class="form-label">Date</label>
          <month-picker-input :default-month="defaultMonth" @change="onDateChange"></month-picker-input>
        </div>

        <div v-for="(type, i) of expenditureType" :key="'modal-projection-' + i" class="form-group">
          <div v-if="type['form']">
            <label class="form-label">{{ type['text'] }}</label>
            <input
              type="number"
              class="form-control bg-transparent pl-3"
              :placeholder="type['text']"
              v-model="data[type['id']]">
          </div>
        </div>

      </form>
      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <div class="d-flex">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
            <b-button class="ml-1" variant="primary" @click="save">{{ $t('button_link.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <div :class="{ 'show': showLoading }" class="modal fade">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content border-0 ">
          <div class="modal-body text-center">
            <div class="spinner-border text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div class="text-light mt-2">{{ $t('message.data.fetching_wait') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { MonthPickerInput } from 'vue-month-picker'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import Swal from "sweetalert2";

export default {
  name: 'expensesProjectionForm',
  props: {
    outlets: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
    expenditureType: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
  },
  components: {
    MonthPickerInput,
  },
  data() {
    return {
      showLoading: false,
      showMonth: false,

      defaultMonth: new Date().getMonth() + 1,
      
      selectedDate: null,
      selectedOutlet: {},
      date: moment(),
      data: {},
    }
  },
  watch: {
    "$i18n.locale"(val) {
    },
  },
  methods: {
    formatExpenditureType(text) {
      let list = []
      let suffix = '_others'
      text = text.endsWith(suffix) ? text.substring(0, text.length - suffix.length) : text
      let temp = text.split('_')
      for (let test of temp) {
        list.push(test.charAt(0).toUpperCase() + test.slice(1))
      }
      return list.join(' ')
    },

    show(selectedOutlet, showMonth) {
      this.$refs['expensesProjectionModal'].show()
      this.selectedOutlet = selectedOutlet
      this.showMonth = showMonth
      this.data = {}

      if(this.showMonth) {
        this.selectedDate = new Date()
        this.defaultMonth = this.selectedDate.getMonth() + 1
      }

      this.load()
    },

    onDateChange(val) {
      this.selectedDate = val.form

      this.load()
    },

    load() {
      // this.expenditureType = []
      this.showLoading = true
      this.data = {}

      let url = `/outlets/${this.selectedOutlet.id}/acct/`

      if(this.showMonth) {
        url += `${new moment(this.selectedDate).format('YYYY-MM-DD')}/expenses`
      } else {
        url += 'default/expenses'
      }

      this.$axios({
        method: 'get',
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$util.getSessionToken() },
      })
        .then((response) => {
            let temp = response.data[0]
            for (let key in temp) {
              // if(key.endsWith('others') && !key.startsWith('vendor')) {
              //   this.expenditureType.push(key)
              // }
              this.data[key] = temp[key]
            }

            this.showLoading = false
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },

    save() {
      let url = `/outlets/${this.selectedOutlet.id}/acct/default/expenses`

      this.$axios({
        method: 'post',
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$util.getSessionToken() },
        data: this.data,
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Set Projection",
            text: `Successfully set project`,
          });

          this.$refs['expensesProjectionModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },

    closeModal(isError) {
      if (!isError) {
        this.$refs['expensesProjectionModal'].hide()
        this.$emit('onModalClose')
      }
    }
  },
  async mounted() {
  }
}
</script>
<style scoped>
.show {
  display: block;
}

.nav-link,
.link {
  cursor: pointer;
}

.img-thumbnail {
  width: 20em;
}

.item-image {
  width: 8em;
  opacity: .5;
}

.error-validation {
  font-size: 0.6875rem;
  margin-top: 0.325rem;
  color: #fd3995;
}

.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>